import http from '@root/utils/axios/admin';

let state = {
    GiveawaysList: [],

}

let actions = {

    fetchGiveawaysList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/giveaways', { params: filter }).then((response) => {
                commit('setGiveawaysList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    excludeGame({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/giveaways/exclude', data).then((response) => {
                resolve(response);
            }).catch((error) => {
                reject(error.response);
            })
        });

    },
    restoreGame({ commit }, id) {
        return http.delete('user/giveaways/restore/' + id);

    },


}


let mutations = {
    setGiveawaysList(state, data) {
        state.GiveawaysList = data;
    },


}

export default {
    state,
    actions,
    mutations
}